import { Label } from 'components/Select/SelectStyles';
import styled from 'styled-components/macro';

export const Header = styled.h2`
  font-size: 21px;
  color: #444;
  margin: 0;
`;

export const ControlLabel = styled(Label)`
  margin-right: 5px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
`;
export const ControlWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
`;

export const Controls = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: right;
  flex-wrap: wrap;
  row-gap: 10px;
  column-gap: 10px;
  @media (max-width: 1605px) {
    justify-content: left;
  }
`;

export const Container = styled.div`
  margin: 20px 0;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 18px;
  @media (max-width: 1605px) {
    flex-direction: column;
    row-gap: 5px;
  }
`;

export const Link = styled.a`
  color: #0076c0;
  cursor: pointer;
`;

export const TableWrapper = styled.div`
  max-width: 400px;
  margin-bottom: 75px;
`;

export const DifferenceWrapper = styled.div`
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: end;
  column-gap: 5px;
`;

export const DifferenceValue = styled.div`
  width: 40px;
`;

export const Spacer = styled.div`
  flex: 1;
  @media (max-width: 1605px) {
    display: none;
  }
`;
